import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { candidateDetailActions } from 'app/components/Candidate/CandidateProfile/Profile/CandidateDetails.redux';
import { SearchResultsPage } from 'app/components/GlobalSearch/SearchResultsPage';
import { SearchType } from 'app/models/GlobalSearch/GlobalSearch';
import { selectUser } from 'oidc/user.selectors';
import { Concatenate } from 'utils/string/string';
import { candidateSearchFilterName } from 'app/components/GlobalSearch/Candidate/SearchUtils';
import { initialCandidateAggregateSearch } from 'app/ComponentLibrary/Filter/CandidateSearch';
import { initialCandidateSkillSetFilter } from 'app/ComponentLibrary/Filter/CandidateSkillset';
import { TagsCandidateSearchFilters } from './TagsCandidateSearchFilters';

const GRID_TAG = `GlobalSearchGrid-${SearchType.tagsCandidateSearch}`;

export const CandidateTagsSearchTab = () => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector(selectUser);

  useEffect(() => {
    dispatch(candidateDetailActions.getTagTypes({ active: 'active', withTimestamp: true }));
  }, [dispatch]);

  const defaultFilterValues = useMemo(
    () => ({
      [candidateSearchFilterName.recruiter]:
        userInfo?.employeeId
          ? [
              {
                id: 0,
                name: Concatenate([userInfo.firstName || '', userInfo.lastName || ''], ' '),
                value: userInfo.employeeId.toString(),
              },
            ]
          : [],
      [candidateSearchFilterName.candidateAgggreggate]: initialCandidateAggregateSearch,
      [candidateSearchFilterName.brand]: [],
      [candidateSearchFilterName.candidateStatus]: [],
      [candidateSearchFilterName.candidateSkillSet]: initialCandidateSkillSetFilter,
      [candidateSearchFilterName.candidateTags]: [],
      activePlacements: null,
    }),
    [userInfo?.employeeId, userInfo?.firstName, userInfo?.lastName],
  );

  return (
    <SearchResultsPage
      category={SearchType.tagsCandidateSearch}
      gridTag={GRID_TAG}
      searchString=""
      title=""
      gridTitleTranslationKey="tagsManagement.candidateTags.gridTitle"
      defaultFilterValues={defaultFilterValues}
      Filters={<TagsCandidateSearchFilters defaultFilterValues={defaultFilterValues} gridTag={GRID_TAG} />}
    />
  );
};

